import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=e097e35a&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"
import style0 from "./setting.vue?vue&type=style&index=0&id=e097e35a&prod&lang=scss&scoped=true"
import style1 from "./setting.vue?vue&type=style&index=1&id=e097e35a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e097e35a",
  null
  
)

export default component.exports